import { Link } from 'react-router-dom';
import { featuredContent } from '@/mocks/sportsData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20panorama%20with%20multiple%20sports%20silhouettes%20including%20football%20soccer%20basketball%20and%20tennis%20players%20in%20motion%2C%20dramatic%20warm%20golden%20lighting%20with%20orange%20and%20amber%20tones%2C%20artistic%20abstract%20composition%20with%20sweeping%20curved%20lines%20and%20geometric%20patterns%2C%20epic%20cinematic%20atmosphere%20with%20particles%20of%20light%20scattered%20across%20the%20scene%2C%20professional%20sports%20branding%20aesthetic&width=1800&height=900&seq=hero-main-bg&orientation=landscape"
        alt="开体育在线 - 体育赛事在线平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="animate-fadeInUp">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 tracking-wide mb-4">
            {featuredContent.heroTitle}
          </h1>
          <p className="font-heading text-lg md:text-2xl text-background-100/90 mb-3 font-light tracking-wider">
            {featuredContent.heroSubtitle}
          </p>
          <p className="text-sm md:text-base text-background-200/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            {featuredContent.heroDescription}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/football"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer transform hover:scale-105"
            >
              查看赛事
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-semibold text-sm whitespace-nowrap hover:bg-background-50/25 transition-all duration-300 cursor-pointer transform hover:scale-105"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeInUp { animation: fadeInUp 0.8s ease-out forwards; }
      `}</style>
    </section>
  );
}